<template>
  <ul :class="$style.list">
    <li>联系人：{{ data.name }}</li>
    <li v-if="data.qq">
      <span :class="$style.qq">联系qq：</span>{{ data.qq }}
    </li>
    <li v-if="data.tel">
      <span :class="$style.tel">联系电话：</span>{{ data.tel }}
    </li>
    <li v-if="data.email">
      <span :class="$style.email">联系邮箱：</span>{{ data.email }}
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default() {
        return {}
      },
    },
  },
}
</script>

<style lang="less" module>
.list {
  flex: 0 0 33.3333%;
  margin-top: 0.3rem;

  li {
    display: flex;
    align-items: center;

    &:not(:first-child) {
      margin-top: 1em;
    }
  }

  span {
    .size(14px);
    .text-hide();
    display: block;
    margin-right: 7px;
    background: url('./images/business-icon.png') no-repeat;
    background-size: 300% 100%;
    white-space: nowrap;

    &.qq {
      background-position: 0 0;
    }

    &.tel {
      background-position: 50% 0;
    }

    &.email {
      background-position: 100% 0;
    }
  }
}
</style>
